const preselectVariant = ({
  variantsData,
  optionNames,
  form,
  selectedOptions,
  updateSelectedOption,
  updateVariantDetails,
  variantIdInput,
}) => {
  const url = new URL(window.location.href);
  let variantId = null;

  if (variantIdInput) {
    variantId = variantIdInput.value;
  }
  else {
    variantId = url.searchParams.get('variant');
  }

  if (!variantId) return;

  const variant = variantsData.find(v => String(v.id) === variantId);
  if (!variant) return;

  optionNames.forEach((name, i) => {
    const value = variant[`option${i + 1}`];
    selectedOptions[name] = value;

    const input = form.querySelector(`[name="${name}"][value="${value}"]`);
    if (input) {
      input.checked = true;
    } else {
      const select = form.querySelector(`select[name="${name}"]`);
      if (select) select.value = value;
    }

    updateSelectedOption(selectedOptions, name, value, updateVariantDetails);
  });
};

export default preselectVariant;
